    <header>
    <img src="logo_te.svg" width="60" title="TotalEnergies" alt="TotalEnergies" class="logo me-4 pointer" routerLink="/home" />
    <div class="header-right">
        <div class="header-top">
            <div class="me-auto header-title">
                <div class="app-name me-3">
                    {{'general.app_name' | translate}}
                </div>
            </div>
            @if(user() && (user()?.workspaces?.length ?? 0) > 1) {
                <ng-container>
                    <button id="workspace-selector" [matMenuTriggerFor]="account" class="ms-auto quartery-btn" mat-raised-button (click)="workspaceExpanded = !workspaceExpanded">
                        
                        <span>{{userService.getCurrentWorkspace() ? userService.getCurrentWorkspace()!.label : ''}}</span>
                        <div class="icon-override arrow-{{workspaceExpanded ? 'top' : 'down'}}-icon size-20" style="margin-left: 12px"></div>
                    </button>
                    <mat-menu class="mt-2" #account="matMenu" [overlapTrigger]="false" (closed)="workspaceExpanded = !workspaceExpanded">
                        @for(workspace of user()?.workspaces; track workspace) {
                            <button mat-menu-item class="pr-5" (click)="userService.changeCurrentWorkspace(workspace)">{{ workspace.label }}</button>
                        }
                    </mat-menu>
                </ng-container>
            }
            @if(user()?.workspaces?.length == 1) {
                <ng-container>
                    <button class="ms-auto quartery-btn-no-hover" mat-raised-button>
                        <span>{{userService.getCurrentWorkspace() ? userService.getCurrentWorkspace()!.label : ''}}</span>  
                    </button>
                </ng-container>
            }

            @if (user()) {
                <ng-container>
                    <button [matMenuTriggerFor]="account" class="{{(user()!.workspaces?.length ?? 0) > 0 ? 'ms-4' : 'ms-auto'}} quartery-btn" mat-raised-button (click)="expand()">
                        <span>{{user()!.first_name + ' ' + user()!.last_name?.slice(0, 1)}}.</span>
                        <div class="icon-override arrow-{{expanded ? 'top' : 'down'}}-icon size-20" style="margin-left: 12px"></div>
                    </button>
                    <mat-menu class="mt-2" #account="matMenu" [overlapTrigger]="false" (closed)="expand()">
                        <button mat-menu-item routerLink="/auth/logout">Logout</button>
                    </mat-menu>
                </ng-container>
            }
        </div>

        <div
            class="d-flex"
            [class.justify-content-end]="!mpsUserService.isLoggedIn()"
            [class.justify-content-between]="mpsUserService.isLoggedIn()"
        >
            @if (mpsUserService.isLoggedIn()) {
                <mps-app-navigation></mps-app-navigation>
            }
            @if (translateService.getLangs().length > 1) {
                <div class="lang-dropdown" (click)="toggleDropdown()" (keyup)="toggleDropdown()" tabindex="0" role="button">
                    <a class="lang-link" role="button" attr.aria-label="{{ 'header.aria.change_language'  | translate}}">
                        <mat-icon>language</mat-icon>
                        <span class="current-lang">{{ getCurrentLangLabel() }}</span>
                        <mat-icon>keyboard_arrow_down</mat-icon>
                    </a>
                    <div class="lang-options" [class.open]="isDropdownOpen()">
                        @for(lang of translateService.getLangs(); track lang) {
                            <a
                                mat-list-item
                                (click)="switchLanguage(lang)"
                                (keyup)="switchLanguage(lang)"
                                role="button"
                                tabindex="0"
                                attr.aria-label="{{ 'header.aria.translate_to'  | translate: {lang: getLangLabel(lang)} }}"
                            >
                                {{ getLangLabel(lang) }}
                            </a>
                        }
                    </div>
                </div>
            }
        </div>

        <div (click)="nav?.toggle()" role="navigation" (keyup)="nav?.toggle()" class="burger-container" role="menu">
            <mat-icon class="burger menu" [ngClass]="{'active': !nav?.opened}">menu</mat-icon>
            <mat-icon class="burger close" [ngClass]="{'active': nav?.opened}">close</mat-icon>
        </div>
    </div>
</header>
